import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import { BookmarkTabs } from "@/shared/Components";
import {
  currentPersonSelector,
  updateIsLoadingSelector,
  isNewPersonSelector,
} from "@/pages/ContactsPage/slice";
import { useAppSelector } from "@/services/store";
import { appRouterPaths } from "@/services/navigation";
import { useBlockingModal, useInvalidContactModal } from "@/services/blocking-modal";
import { contactsTabs } from "../../../constants";
import styles from "./styles.module.scss";

export const ContactsTabsDesktop = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { executeWithModal } = useBlockingModal(updateIsLoadingSelector);
  const { executeWithConfirm } = useInvalidContactModal();

  const isNewPerson = useAppSelector(isNewPersonSelector);
  const currentPerson = useAppSelector(currentPersonSelector);

  const activeKey = location.pathname.split("/")[2];

  const generatePath = (tabValue: any) => {
    if (currentPerson?.id) return `${appRouterPaths.contacts.base}/${tabValue}/${currentPerson.id}`;
    return tabValue;
  };

  const tabs = contactsTabs.map((item) => {
    if (item.id === 1) return item;
    return { ...item, disabled: isNewPerson || !currentPerson };
  });

  const navigateOnPath = (value: any) => {
    navigate(generatePath(value));
  };

  const formSegmentedChange = (key: any) => {
    const confirmAction = executeWithConfirm(() => {
      navigateOnPath(key);
    });

    confirmAction();
  };

  const changeSegmentHandler = (tabKey: any) => {
    if (activeKey === "generalInfo" || activeKey === "activities") {
      formSegmentedChange(tabKey);
      return;
    }
    navigateOnPath(tabKey);
  };

  const handleSegmentChange = (tabKey: any) => {
    executeWithModal(() => changeSegmentHandler(tabKey));
  };

  return (
    <>
      <div className={styles.tabs}>
        <BookmarkTabs
          activeTabClassName={styles["active-tab"]}
          tabClassName={classNames(styles.tab)}
          onChange={handleSegmentChange}
          activeValue={activeKey}
          tabs={tabs}
        />
      </div>
    </>
  );
};
